import React from "react";
import { RxCounterClockwiseClock } from "react-icons/rx";
import ScrollAnimation from 'react-animate-on-scroll';

import Sp_Panel_1_1 from '../../img/program-preview/sp_1_1.webp'
import Sp_Panel_1_2 from '../../img/program-preview/sp_1_2.webp'
import Sp_Panel_1_3 from '../../img/program-preview/sp_1_3.webp'
import Sp_Panel_1_4 from '../../img/program-preview/sp_1_4.webp'

import Sp_Panel_2_1 from '../../img/program-preview/sp_2_1.webp'
import Sp_Panel_2_2 from '../../img/program-preview/sp_2_2.webp'
import Sp_Panel_2_3 from '../../img/program-preview/sp_2_3.webp'
import Sp_Panel_2_4 from '../../img/program-preview/sp_2_4.webp'

import Sp_Panel_3_1 from '../../img/program-preview/sp_3_1.webp'
import Sp_Panel_3_2 from '../../img/program-preview/sp_3_2.webp'
import Sp_Panel_3_3 from '../../img/program-preview/sp_3_3.webp'
import Sp_Panel_3_4 from '../../img/program-preview/sp_3_4.webp'
import Sp_Panel_3_5 from '../../img/program-preview/sp_3_5.webp'

import Sp_Panel_4_1 from '../../img/program-preview/sp_4_1.webp'
import Sp_Panel_4_2 from '../../img/program-preview/sp_4_2.webp'
import Sp_Panel_4_3 from '../../img/program-preview/sp_4_3.webp'
import Sp_Panel_4_4 from '../../img/program-preview/sp_4_4.webp'
import Sp_Panel_4_5 from '../../img/program-preview/sp_4_5.webp'
import Sp_Panel_4_6 from '../../img/program-preview/sp_4_6.webp'
import Sp_Panel_4_7 from '../../img/program-preview/sp_4_7.webp'

import Sp_Panel_5_1 from '../../img/program-preview/sp_5_1.webp'
import Sp_Panel_5_2 from '../../img/program-preview/sp_5_2.webp'
import Sp_Panel_5_3 from '../../img/program-preview/sp_5_3.webp'
import Sp_Panel_5_4 from '../../img/program-preview/sp_5_4.webp'
import Sp_Panel_5_5 from '../../img/program-preview/sp_5_5.webp'


import Sp_Panel_6_1 from '../../img/program-preview/sp_6_1.webp'
import Sp_Panel_6_2 from '../../img/program-preview/sp_6_2.webp'
import Sp_Panel_6_3 from '../../img/program-preview/sp_6_3.webp'
import Sp_Panel_6_4 from '../../img/program-preview/sp_6_4.webp'
import Sp_Panel_6_5 from '../../img/program-preview/sp_6_5.webp'

import Sp_Panel_7_1 from '../../img/program-preview/sp_7_1.webp'
import Sp_Panel_7_2 from '../../img/program-preview/sp_7_2.webp'
import Sp_Panel_7_3 from '../../img/program-preview/sp_7_3.webp'
import Sp_Panel_7_4 from '../../img/program-preview/sp_7_4_1.webp'

import Sp_Panel_8_1 from '../../img/program-preview/sp_8_1.webp'


import Secret_Speaker from '../../img/program-preview/secret_speaker.webp'

import Sp_1 from '../../img/program-preview/sp_1.webp'
import Sp_2 from '../../img/program-preview/sp_2.webp'
import Sp_7 from '../../img/program-preview/sp_7.webp'

import Sp_3 from '../../img/program-preview/sp_3.webp'
import Sp_4 from '../../img/program-preview/sp_4.webp'
import Sp_5 from '../../img/program-preview/sp_5.webp'
import Sp_6 from '../../img/program-preview/sp_6.webp'

import Sp_logo_1 from '../../img/program-preview/sp_logo_1.svg'
import Sp_logo_2 from '../../img/program-preview/sp_logo_2.webp'
import Sp_logo_3 from '../../img/program-preview/sp_logo_3.webp'
import Sp_logo_4 from '../../img/program-preview/sp_logo_4.png'
import Sp_logo_5 from '../../img/program-preview/sp_logo_5.webp'

import SiteDecor from "../../img/site-decor.webp"


const speakerGradients = [
    'bg-[linear-gradient(180deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]',
    'bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]',
    'bg-[linear-gradient(205deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]',
    'bg-[linear-gradient(68deg,_rgba(0,144,100,0)_0%,_rgba(24,170,126,0.75)_66.35%,_#ece66a_100%)]',
    'bg-[linear-gradient(180deg,_rgba(0,144,100,0)_0%,_rgba(24,170,126,0.75)_66.35%,_#ece66a_100%)]',
    'bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]',
];
const speakers = [
  {
    img: Sp_1,
    name: "Артем Бородатюк",
    position: "засновник групи IT-компаній FRACTAL",
  },
  {
    img: Sp_2,
    name: "Владислав Антипов",
    position: "власник та СЕО екологічної компанії ЦЕРН",
  },
];

function  EventProgramPreview() {

    return (
        <section className="mb-14 lg:mb-32" id="programm">
            <div className="mb-14 lg:mb-22">
                <div className="container max-w-screen-xl mx-auto pb-8 px-4">
                    <h2 className="text-center font-bold uppercase text-3xl text-[#000] mb-6 sm:text-4xl lg:text-[60px]">Програма 2026</h2>
                    <p className="text-[#adadad] mb-9 md:mb-14 font-normal text-center">
                        *Програма заходу та порядок виступів можуть змінюватися. Слідкуйте за оновленнями!
                    </p>
                    <div className="py-3 px-5 mb-4 bg-[rgba(149,200,191,0.15)]">
                        <div className="flex flex-wrap items-center gap-x-3 md:gap-5 md:flex-nowrap lg:text-xl">
                            <RxCounterClockwiseClock className="text-[#000]"/>
                            <span>09:00 – 09:40</span>
                            <h4 className="flex-[100%] md:flex-1 font-bold ">Реєстрація та велкам-кава від Foundation Coffee Roasters</h4>
                        </div>
                    </div>
                    <div className="py-3 px-5 mb-4 bg-[rgba(149,200,191,0.15)]">
                        <div className="flex flex-wrap items-center gap-x-3 md:gap-5 md:flex-nowrap lg:text-xl mb-4 lg:mb-8">
                            <RxCounterClockwiseClock className="text-[#000]"/>
                            <span>09:40 – 09:55</span>
                            <h4 className="flex-[100%] md:flex-1 font-bold ">Вітальне слово ведучої</h4>
                        </div>
                        <div className="flex flex-col md:flex-wrap items-center md:items-stretch gap-5 sm:flex-row sm:gap-5 lg:gap-10">
                            <div className="lg:w-[calc(100%-180px)] lg:ml-auto pb-8 mb-6 md:mb-10 border-b border-[#009064]">
                                <div className="flex flex-col md:flex-wrap items-center md:items-stretch
                                    gap-5 sm:flex-row sm:gap-5 lg:gap-10">
                                    <div className="max-w-[180px] flex flex-col w-full">
                                        {/* Фото + градиент */}
                                        <div className='p-[2px] overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                            <div className="relative overflow-hidden">
                                                <img src={Sp_Panel_8_1} alt='Оксана Гутцайт' className="w-full h-full object-cover relative z-10"/>
                                                <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                            </div>
                                        </div>
                                        {/* Текст */}
                                        <div className="bg-white py-2 px-4 flex-grow">
                                            <h4 className="font-bold uppercase text-xs">
                                                Оксана Гутцайт
                                            </h4>
                                            <p className="text-[10px] text-gray-600">
                                                Ведуча програми «Факти» на ICTV
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="py-3 px-5 mb-4">
                        <div className="flex flex-wrap items-center gap-x-3 md:gap-5 md:flex-nowrap lg:text-xl mb-4 lg:mb-8">
                            <RxCounterClockwiseClock className="text-[#000]"/>
                            <span>09:55 – 10:00</span>
                            <h4 className="flex-[100%] md:flex-1 font-bold ">Вітальне слово організаторів</h4>
                        </div>
                        <div className="flex flex-col md:flex-wrap items-center md:items-stretch gap-5 sm:flex-row sm:gap-5 lg:gap-10">
                            <div className="lg:w-[calc(100%-180px)] lg:ml-auto pb-8 mb-6 md:mb-10 border-b border-[#009064]">
                                <div className="flex flex-col md:flex-wrap items-center md:items-stretch
                                    gap-5 sm:flex-row sm:gap-5 lg:gap-10">
                                    <div className="max-w-[180px] flex flex-col w-full">
                                        {/* Фото + градиент */}
                                        <div className='p-[2px] overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                            <div className="relative overflow-hidden">
                                                <img src={Sp_Panel_4_1} alt='Тетяна Смірнова' className="w-full h-full object-cover relative z-10"/>
                                                <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                            </div>
                                        </div>
                                        {/* Текст */}
                                        <div className="bg-white py-2 px-4 flex-grow">
                                            <h4 className="font-bold uppercase text-xs">
                                                Тетяна Смірнова
                                            </h4>
                                            <p className="text-[10px] text-gray-600">
                                                CЕО бізнес/медіа бюро еkonomika+
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="py-3 px-5 mb-4 bg-[rgba(149,200,191,0.15)] pb-4 md:pb-8 xl:pb-14">
                        <div className="flex flex-wrap items-center gap-x-3 mb-4 md:gap-5 md:flex-nowrap lg:mb-8 lg:text-xl">
                            <RxCounterClockwiseClock className="text-[#000]"/>
                            <span>10:00 - 14:00</span>
                            <h4 className="flex-[100%] md:flex-1 font-bold ">Перша частина. Панельні дискусії: </h4>
                        </div>
                        <div className="lg:w-[calc(100%-180px)] lg:ml-auto pb-8 mb-6 md:mb-10 border-b border-[#009064]">
                            <div className="flex gap-4 pb-5 mb-5">
                                <div class="w-3 h-3 mt-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                <div className="lg:flex lg:gap-7 xl:gap-11">
                                    <p className="mb-3 lg:mb-0 flex-shrink-0 lg:w-[30%]">
                                        <strong>Білий бізнес: обовʼязок чи стратегія зростання?</strong>
                                    </p>
                                    <p>
                                        Чи є прозорість конкурентною перевагою чи лише вимогою? 
                                        Які умови держава має створити для розвитку «білої» економіки? 
                                        Як скоротити тіньовий сектор без надмірного тиску?
                                    </p>
                                </div>
                            </div>  
                            <div className="flex flex-col items-center md:flex-wrap md:items-stretch
                                gap-5 sm:flex-row sm:gap-5 lg:gap-10">
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_1_1} alt='Євген Ріяко' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Євген Ріяко
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            СЕО юридичної компанії RIYAKO&PARTNERS
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_1_2} alt='Євген Ріяко' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Андрій Лукасевич
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            юрист, менеджер з протидії нелегальній торгівлі ТОВ «Філіп Морріс Україна»
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_1_3} alt='Євген Ріяко' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Данило Гетманцев
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            Голова комітету Верховної ради України з питань фінансів, податкової та митної політики
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_1_4} alt='Василь Даниляк' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Василь Даниляк
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            СЕО Групи компаній ОККО
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="lg:w-[calc(100%-180px)] lg:ml-auto pb-8 mb-6 md:mb-10 border-b border-[#009064]">
                            <div className="flex gap-4 pb-5 mb-5">
                                <div class="w-3 h-3 mt-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                <div className="lg:flex lg:gap-7 xl:gap-11">
                                    <p className="mb-3 lg:mb-0 flex-shrink-0 lg:w-[30%]">
                                        <strong>Трансформація українського експорту у світовому економічному просторі</strong>
                                    </p>
                                    <p>
                                        Як українському бізнесу найпростіше інтегруватися у міжнародні ринки та які бар’єри є найскладнішими?
                                        Які формати партнерства працюють найкраще?
                                        Що є ключовою цінністю України для міжнародних партнерів?
                                    </p>
                                </div>
                            </div>  
                            <div className="flex flex-col items-center md:flex-wrap md:items-stretch
                                gap-5 sm:flex-row sm:gap-5 lg:gap-10">
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_3_1} alt='Олена Борисова' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Олена Борисова
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            СЕО та власниця Gastro Family
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_3_2} alt="Анна Дерев'янко" className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Анна Дерев'янко
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            виконавча директорка Європейської Бізнес Асоціації
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_3_3} alt='Геннадій Чижиков' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Геннадій Чижиков
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            Президент Торгово-промислової палати України
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_3_4} alt='Олег Заплетнюк' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Олег Заплетнюк
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            Генеральний директор ТОВ "ТАС Агро"
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_3_5} alt='Дмитро Кисилевський' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Дмитро Кисилевський
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            Заступник голови Комітету Верховної Ради з питань економічного розвитку, народний депутат України
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="lg:w-[calc(100%-180px)] lg:ml-auto pb-8 mb-6 md:mb-10 border-b border-[#009064]">
                            <div className="flex gap-4 pb-5 mb-5">
                                <div class="w-3 h-3 mt-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                <div className="lg:flex lg:gap-7 xl:gap-11">
                                    <p className="mb-3 lg:mb-0 flex-shrink-0 lg:w-[30%]">
                                        <strong>Зростання під тиском</strong>
                                    </p>
                                    <p>
                                        Як компанії адаптуються до втрат і ризиків у нестабільний час?
                                        Чи працюють механізми компенсацій і страхування?
                                        Як зберегти доступ до фінансування в умовах високих ризиків?
                                    </p>
                                </div>
                            </div>  

                            <div className="flex flex-col items-center md:flex-wrap md:items-stretch
                                gap-5 sm:flex-row sm:gap-5 lg:gap-10">
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_2_1} alt='Євген Ріяко' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Олександр Лещенко
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            керуючий партнер юридичної компанії LESHCHENKO & PARTNERS
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_2_2} alt='Євген Ріяко' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Юлія Пономаренко
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            фінансова директорка AbInBev Efes Україна
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_2_3} alt='Євген Ріяко' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Ольга Василевська - Смаглюк
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            Народний депутат України
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_2_4} alt='Тарас Шидлик' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Тарас Шидлик
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            Член правління, фінансовий директор Starlight Media
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Secret_Speaker} alt='Secret_Speaker' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Secret Speaker
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="lg:w-[calc(100%-180px)] lg:ml-auto pb-8 mb-6 md:mb-10 border-b border-[#009064]">
                            <div className="flex gap-4 pb-5 mb-5">
                                <div class="w-3 h-3 mt-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                <div className="lg:flex lg:gap-7 xl:gap-11">
                                    <p className="mb-3 lg:mb-0 flex-shrink-0 lg:w-[30%]">
                                        <strong>Бізнес і суспільство: як змінюються правила соціальної відповідальності</strong>
                                    </p>
                                    <p>
                                        Як змінюється роль компаній та лідерів думок у відповідь на соціальні виклики?
                                        Які соціальні ініціативи стають стратегічними?
                                        Як масштабувати соціальний вплив, зокрема, у підтримці громад та ветеранів та ветеранок? 
                                    </p>
                                </div>
                            </div>  
                            <div className="flex flex-col md:flex-wrap items-center md:items-stretch
                                gap-5 sm:flex-row sm:gap-5 lg:gap-10">
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_4_1} alt='Тетяна Смірнова' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Тетяна Смірнова
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            CЕО бізнес/медіа бюро еkonomika+
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_4_2} alt="Тарас Кицмей" className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Тарас Кицмей
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            співзасновник та член Ради директорів SoftServe
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_4_3} alt='Сергій Притула' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Сергій Притула
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            засновник благодійного фонду Сергія Притули
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_4_4} alt='Галина Соловей' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Галина Соловей
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            генеральна директорка благодійної організації «Фундація Дім Рональда МакДональда в Україні»
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_4_5} alt='Юлія Ярмоленко' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Юлія Ярмоленко
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            СЕО компанії «Київський БКК»
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_4_6} alt='Ірина Метньова' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Ірина Метньова
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            директорка Vandog Agency
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_4_7} alt='Людмила Новак' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Людмила Новак
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            Директорка з комунікацій Інтерпайп
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="py-3 px-5 mb-4">
                        <div className="flex flex-wrap items-center gap-x-3 md:gap-5 md:flex-nowrap lg:text-xl">
                            <RxCounterClockwiseClock className="text-[#000]"/>
                            <span>14:00 - 15:00</span>
                            <h4 className="flex-[100%] md:flex-1 font-bold ">Перерва та нетворкінг</h4>
                        </div>
                    </div>

                    <div className="py-3 px-5 mb-4 bg-[rgba(149,200,191,0.15)] pb-4 md:pb-8 xl:pb-14">
                        <div className="flex flex-wrap items-center gap-x-3 mb-4 md:gap-5 md:flex-nowrap lg:mb-8 lg:text-xl">
                            <RxCounterClockwiseClock className="text-[#000]"/>
                            <span>15:00 - 18:00</span>
                            <h4 className="flex-[100%] md:flex-1 font-bold ">Друга частина. Панельні дискусії:</h4>
                        </div>
                        <div className="lg:w-[calc(100%-180px)] lg:ml-auto pb-8 mb-6 md:mb-10 border-b border-[#009064]">
                            <div className="flex gap-4 pb-5 mb-5">
                                <div class="w-3 h-3 mt-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                <div className="lg:flex lg:gap-7 xl:gap-11">
                                    <p className="mb-3 lg:mb-0 flex-shrink-0 lg:w-[30%]">
                                        <strong>Неочевидний ШІ: від експериментів до захисту бізнесу</strong>
                                    </p>
                                    <p>
                                        Як відрізнити ефективні кейси від хайпу?
                                        Де ШІ створює реальну бізнес-цінність?
                                        Як оцінювати ризики та що саме захищати, коли компанії використовують ШІ-сервіси?
                                    </p>
                                </div>
                            </div> 
                            <div className="flex flex-col items-center md:flex-wrap md:items-stretch gap-5 sm:flex-row sm:gap-5 lg:gap-10">
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_5_1} alt='Сергій Мартинчук' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Сергій Мартинчук
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            генеральний директор Cisco Ukraine
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_5_2} alt='Олександр Краковецький' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Олександр Краковецький
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            CEO DevRain
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_5_3} alt='Євгеній Бачинський' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Євгеній Бачинський
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            Vice President, Head of Management Consultancy, AI-директор Sigma Software
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_5_4} alt='Наталія Лященко' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Наталія Лященко
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            Acting director телеканал КИЇВ24
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_5_5} alt='Микола Ткаченко' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Микола Ткаченко
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            директор департаменту розвитку інформаційних технологій агропромхолдингу «Астарта-Київ»
                                        </p>
                                    </div>
                                </div>
                                
                            </div> 
                        </div>
                        <div className="lg:w-[calc(100%-180px)] lg:ml-auto pb-8 mb-6 md:mb-10 border-b border-[#009064]">
                            <div className="flex gap-4 pb-5 mb-5">
                                <div class="w-3 h-3 mt-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                <div className="lg:flex lg:gap-7 xl:gap-11">
                                    <p className="mb-3 lg:mb-0 flex-shrink-0 lg:w-[30%]">
                                        <strong>Шлях до енергоефективності: стратегія, фінансування, результати</strong>
                                    </p>
                                    <p>
                                        Як інтегрувати енергоефективність у стратегію розвитку?
                                        Де знайти фінансування для енергопроєктів і як оцінюються ризики?
                                        Які рішення реально дають вимірюваний ефект?
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col items-center md:flex-wrap md:items-stretch gap-5 sm:flex-row sm:gap-5 lg:gap-10">
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_7_1} alt='Яна Шумунова' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Яна Шумунова
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                           директорка департаменту МСБ Sense Bank
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_7_2} alt='Ольга Рибачук' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Ольга Рибачук
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                           керуюча директорка Elementum Energy
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_7_3} alt='Сергій Коваленко' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Сергій Коваленко
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                           CEO YASNO
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_7_4} alt='Сергій Євтушенко' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Сергій Євтушенко
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            засновник, керівний партнер та CEO UDP Renewables
                                        </p>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div className="lg:w-[calc(100%-180px)] lg:ml-auto pb-8 mb-6 md:mb-10 border-b border-[#009064]">
                            <div className="flex gap-4 pb-5 mb-5">
                                <div class="w-3 h-3 mt-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                <div className="lg:flex lg:gap-7 xl:gap-11">
                                    <p className="mb-3 lg:mb-0 flex-shrink-0 lg:w-[30%]">
                                        <strong>Бізнеси сміливих: нова логіка економічного зростання </strong>
                                    </p>
                                    <p>
                                        Як змінюється архітектура бізнесу у відповідь на нові виклики? 
                                        Які елементи компанії потребують найбільшої трансформації?
                                        Де знаходяться точки зростання під час війни?
                                    </p>
                                </div>
                            </div>  
                            <div className="flex flex-col items-center md:flex-wrap md:items-stretch gap-5 sm:flex-row sm:gap-5 lg:gap-10">
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_6_1} alt='Віталій Лубінець' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Віталій Лубінець
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            співзасновник та СЕО WIN WIN CLUB
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                    {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden 
                                        bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]'>
                                        <div className="relative overflow-hidden">
                                            <img src={Sp_Panel_6_2} alt='Олександр Білий' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Олександр Білий
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            виконавчий та фінансовий директор 1+1 media
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_6_3} alt='Марина Мкртичева' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Марина Мкртичева
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            керуюча партнерка, керівниця практики Business Protection & WCC в Magnet Legal Law Firm
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_6_4} alt='Михайло Шнейдер' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Михайло Шнейдер
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            СЕО KSE
                                        </p>
                                    </div>
                                </div>
                                <div className="max-w-[180px] flex flex-col w-full">
                                {/* Фото + градиент */}
                                    <div className='p-[2px] overflow-hidden'>
                                        <div className="relative overflow-hidden 
                                            bg-[linear-gradient(270deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                            <img src={Sp_Panel_6_5} alt='Тимур Козонов' className="w-full h-full object-cover relative z-10"/>
                                            <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                        </div>
                                    </div>
                                    {/* Текст */}
                                    <div className="bg-white py-2 px-4 flex-grow">
                                        <h4 className="font-bold uppercase text-xs">
                                            Тимур Козонов
                                        </h4>
                                        <p className="text-[10px] text-gray-600">
                                            засновник Foundation Coffee Roasters
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="lg:w-[calc(100%-180px)] lg:ml-auto pb-8 mb-6 md:mb-10 border-b border-[#009064]">
                            <div className="flex gap-4 pb-5 mb-5">
                                <div class="w-3 h-3 mt-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                <div className="lg:flex lg:gap-7 xl:gap-11">
                                    <p className="mb-3 lg:mb-0 flex-shrink-0 lg:w-[30%]">
                                        <strong>Ексклюзивний блок заходу:</strong>
                                    </p>
                                    <p>відкритий діалог із залом про найпоширеніші помилки управлінців, які не читали книгу «Для менеджерів» </p>
                                </div>
                            </div>  

                            <div className="flex flex-col items-stretch gap-5 sm:flex-row sm:gap-5 ls:gap-12 xl:gap-16">
                                {speakers.map((speaker, index) => (
                                    <div key={index} className="max-w-[238px] w-full flex flex-col">
                                        {/* Фото + градиент */}
                                        <div className={`p-[2px] overflow-hidden ${speakerGradients[index % speakerGradients.length]}`}>
                                            <div className="h-52 relative overflow-hidden">
                                                <img src={speaker.img} alt={speaker.name} className="w-full h-full object-cover relative z-10"/>
                                                <div className="absolute bottom-0 -right-12 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                                            </div>
                                        </div>
                                        {/* Текст */}
                                        <div className="bg-white py-2 px-4 flex-grow">
                                            <h4 className="font-bold uppercase text-sm">
                                                {speaker.name}
                                            </h4>
                                            <p className="text-sm text-gray-600">
                                                {speaker.position}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>

                    </div>

                    <div className="py-3 px-5 mb-4 pb-5 border-b border-[#009064]">
                        <div className="flex flex-wrap items-center gap-x-3 md:gap-5 md:flex-nowrap lg:text-xl">
                            <RxCounterClockwiseClock className="text-[#000]"/>
                            <span>18:00</span>
                            <h4 className="flex-[100%] md:flex-1 font-bold ">Церемонія нагородження 50 найкращих CEO за версією видання «ТОП-100. Рейтинги найбільших»</h4>
                        </div>
                    </div>
                </div>
            </div>

            
            <div className="bg-[#f1f3f2] py-16 lg:py-[120px]">
                <div className="container max-w-screen-xl mx-auto pb-8 px-4">
                    <h2 className="text-center font-bold uppercase text-3xl text-[#000] mb-6 sm:text-4xl lg:text-[60px]">Інсайтами у сольних виступах </h2>
                    <p className="text-[#adadad] mb-9 md:mb-14 font-normal text-center">на сцені Business Wisdom Summit поділяться </p>

                    <div className="flex flex-col gap-4 md:flex-wrap md:flex-row">
                        <div className="flex h-64 md:max-w-[30%]">
                            <div className="w-1/2 flex-shrink-0 flex flex-col justify-center gap-3 bg-white 
                                pl-4 lg:pl-5 pr-4">
                                <h4 className="font-bold uppercase">Павло Царук</h4>
                                <p className="font-normal text-[13px]">голова правління страхової групи «ТАС»​</p>
                                <img src={Sp_logo_1}  className="max-w-[60%]"/>
                            </div>
                            <div className="w-1/2 flex-shrink-0 flex flex-col justify-end relative
                                bg-[linear-gradient(180deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                <img src={Sp_3}  className="w-full object-cover -ml-10 relative z-10"/>
                                <div className="absolute -top-7 -right-6 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                            </div>
                        </div>
                        <div className="flex md:max-w-[30%] h-64">
                            <div className="w-1/2 flex-shrink-0 flex flex-col justify-center gap-3 bg-white pl-4 lg:pl-5 pr-4">
                                <h4 className="font-bold uppercase">Андрій Семченко</h4>
                                <p className="font-normal text-[13px]">голова правління страхової компанії ІНГО​</p>
                                <img src={Sp_logo_2}  className="max-w-[60%]"/>
                            </div>
                            <div className="w-1/2 flex-shrink-0 flex flex-col justify-end relative
                                bg-[linear-gradient(180deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                <img src={Sp_4}  className="w-full object-cover -ml-10 relative z-10"/>
                                <div className="absolute -top-7 -right-6 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                            </div>
                        </div>
                        <div className="flex md:max-w-[30%] h-64">
                            <div className="w-1/2 flex-shrink-0 flex flex-col justify-center gap-3 bg-white pl-4 lg:pl-5 pr-4">
                                <h4 className="font-bold uppercase">Ілля Польшаков</h4>
                                <p className="font-normal text-[13px]">директор з розвитку нових напрямів бізнесу в Київстар​</p>
                                <img src={Sp_logo_3}  className="max-w-[60%]"/>
                            </div>
                            <div className="w-1/2 flex-shrink-0 flex flex-col justify-end relative
                                bg-[linear-gradient(180deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                <img src={Sp_5}  className="w-full object-cover -ml-10  relative z-10"/>
                                <div className="absolute -top-7 -right-6 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                            </div>
                        </div>
                        <div className="flex md:max-w-[30%] h-64">
                            <div className="w-1/2 flex-shrink-0 flex flex-col justify-center gap-3 bg-white pl-4 lg:pl-5 pr-4">
                                <h4 className="font-bold uppercase">Дарія Марчак</h4>
                                <p className="font-normal text-[13px]">Заступник міністра економіки, довкілля та сільського господарства України​</p>
                                <img src={Sp_logo_4}  className="max-w-[60%]"/>
                            </div>
                            <div className="w-1/2 flex-shrink-0 flex flex-col justify-end relative
                                bg-[linear-gradient(180deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                <img src={Sp_6}  className="w-full object-cover -ml-10  relative z-10"/>
                                <div className="absolute -top-7 -right-6 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                            </div>
                        </div>
                        <div className="flex md:max-w-[30%] h-64">
                            <div className="w-1/2 flex-shrink-0 flex flex-col justify-center gap-3 bg-white pl-4 lg:pl-5 pr-4">
                                <h4 className="font-bold uppercase">Марта Левченко</h4>
                                <p className="font-normal text-[13px]">Засновниця міжнародного центру «Місто добра» і благодійного фонду «Я майбутнє України»​</p>
                                <img src={Sp_logo_5}  className="max-w-[60%]"/>
                            </div>
                            <div className="w-1/2 flex-shrink-0 flex flex-col justify-end relative
                                bg-[linear-gradient(180deg,_#ece66a_0%,_rgba(24,170,126,0.75)_33.65%,_rgba(0,144,100,0)_100%)]">
                                <img src={Sp_7}  className="w-full object-cover -ml-10  relative z-10"/>
                                <div className="absolute -top-7 -right-6 rounded-full w-[90%]"><img src={SiteDecor} /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}

export default EventProgramPreview;